import React, { useState } from "react";
import "./alert.css";

function Declaration({ onNext, onPrev }) {

	const [accepted, setAccepted] = useState(false);
	const [alertData, setAlertData] = useState(null);

	const showAlert = (message, type = "error") => {
		setAlertData({
			message,
			type,
			id: Date.now()
		});

		setTimeout(() => {
			setAlertData(null);
		}, 5000);
	};

	const handleNext = () => {

		if (!accepted) {
			showAlert("Please accept the declaration before proceeding ❗");
			return;
		}

		showAlert("Declaration accepted ✅", "success");

		setTimeout(() => {
			onNext();
		}, 800);
	};

	return (
		<>
			<style>{`

			@keyframes smoothEntry {
				0% {
					opacity: 0;
					transform: translateY(20px);
				}
				100% {
					opacity: 1;
					transform: translateY(0);
				}
			}

			.program-container {
				background: #ffffff;
				padding: 20px;
				border-radius: 12px;
				border: 1px solid #e2e8f0;
				font-family: 'Poppins', sans-serif;
				width: 100%;
				max-width: 850px;
				display: flex;
				flex-direction: column;
				animation: smoothEntry 0.4s ease;
			}

			.program-title {
				font-size: 18px;
				font-weight: 600;
				color: #1e3a8a;
				margin-bottom: 15px;
			}

			.declaration-text {
				font-size: 13px;
				color: #1e293b;
				line-height: 1.6;
				margin-bottom: 15px;
			}

			.declaration-text p {
				margin-bottom: 10px;
			}

			.checkbox-row {
				display: flex;
				align-items: flex-start;
				gap: 10px;
				margin-top: 10px;
				font-size: 13px;
			}

			.checkbox-row input {
				margin-top: 3px;
				cursor: pointer;
			}

			.footer {
				display: flex;
				justify-content: space-between;
				margin-top: 20px;
			}

			.btn {
				padding: 8px 16px;
				border-radius: 6px;
				border: none;
				cursor: pointer;
				font-size: 13px;
			}

			.prev-btn {
				background: #e2e8f0;
			}

			.next-btn {
				background: #2563eb;
				color: white;
			}

			.next-btn:disabled {
				background: #94a3b8;
				cursor: not-allowed;
			}

			/* 📱 Mobile */
			@media (max-width: 768px) {
				.footer {
					flex-direction: column;
					gap: 10px;
				}
				.btn {
					width: 100%;
				}
			}

			`}</style>

			{/* Alert */}
			{alertData && (
				<div className={`custom-alert ${alertData.type}`}>
					<span className="alert-icon">
						{alertData.type === "success" ? "✔" : "❗"}
					</span>
					{alertData.message}
				</div>
			)}

			<div className="program-container">
				<div className="program-title">Declaration</div>

				<div className="declaration-text">
					<p>
						1. Candidates are required to verify all details entered by them, before submitting the online application form. Once application is submitted, no request for correction of any of the details will be entertained.
					</p>

					<p>
						2. I declare that the entries in the Online Application Form have been filled up and the entries made are correct as per my documents and to the best of my knowledge and belief. I agree that if any statement is proved to be false then the Authority shall have the right to take legal action against me for submitting false information or statement. I further declare that there is no allegation of misconduct against me and I have never been convicted for any offence involving moral turpitude.
					</p>
				</div>

				{/* ✅ Checkbox */}
				<div className="checkbox-row">
					<input
						type="checkbox"
						checked={accepted}
						onChange={(e) => setAccepted(e.target.checked)}
					/>
					<label>
						I have read and agree to the above declaration.
					</label>
				</div>

				{/* Footer */}
				<div className="footer">

					<button className="btn prev-btn" onClick={onPrev}>
						⬅ Previous
					</button>

					<button
						className="btn next-btn"
						onClick={handleNext}
						disabled={!accepted}
					>
						Submit ➜
					</button>

				</div>
			</div>
		</>
	);
}

export default Declaration;